import t from"styled-components";import{theme as e}from"../../../theme.js";const o=t.div`
  height: 30px;
  background-color: ${e.colors.secondary[900]};
  width: 100%;
  > div {
    width: ${({fullScreen:i})=>i?"100%":e.maxWidth};
    padding: ${({fullScreen:i})=>i?"0 16px":"0"};
    margin: auto;
  }
  @media screen and (max-width: ${e.breakpoints.xl}) {
    > div {
      width: 100%;
      padding: 0 ${e.spacing*3}px;
    }
  }
`,n=t.div`
  height: 30px;
  display: flex;
  align-items: center;
  gap: ${e.spacing*2}px;
  cursor: pointer;
  > span {
    color: ${e.colors.shades[0]};
    text-decoration: none;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
  }
  > svg { 
    width: 14px;
    height: 14px;
    > g, path {
      fill: ${e.colors.shades[0]};
    }
  }
`;export{o as Container,n as StyledLink};
